import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

// Reducers from each module
// Shared module
import auth from "./../redux/reducers/auth.reducer";
import ui from "./../redux/reducers/ui.reducer";
import home from "./reducers/home.reducer";
import uiShared from "./reducers/uiShared.reducer";
// Billing Module
import filters from "./../../BillingModule/redux/reducers/filters.reducer";
import metaBilling from "../../BillingModule/redux/reducers/metaBilling.reducer";
import billableHours from "./../../BillingModule/redux/reducers/billableHours.reducer";
import billableItems from "./../../BillingModule/redux/reducers/billableItems.reducer";
import invoices from "./../../BillingModule/redux/reducers/invoices.reducer";
// Products Module
import spotlightReportProducts from "./../../ProductsModule/redux/reducers/spotlightReport.reducer";
import metaProducts from "../../ProductsModule/redux/reducers/metaProducts.reducer";
import products from "../../ProductsModule/redux/reducers/products.reducer";
import spotlight from "../../ProductsModule/redux/reducers/spotlight.reducer";
import successCriteria from "../../ProductsModule/redux/reducers/successCriteria.reducer";
// Times Module
import metaTimes from "../../TimesModule/redux/reducers/metaTimes.reducer";
import times from "../../TimesModule/redux/reducers/times.reducer";
import timesQuery from "../../TimesModule/redux/reducers/timesQuery.reducer";
import queryResults from "../../TimesModule/redux/reducers/queryResult.reducer";
import approvalTime from "../../TimesModule/redux/reducers/approvalTime.reducer";
import entryHourBox from "../../TimesModule/redux/reducers/entryHourBox.reducer";
import approvalTimeByUser from "../../TimesModule/redux/reducers/approveTimeByUser.reducer";
import timeConfirmation from "../../TimesModule/redux/reducers/timesConfirmationReport.reducer";
import timeConfirmationResult from "../../TimesModule/redux/reducers/timesConfirmationResults.reducer";
import whoIsOutReport from "../../TimesModule/redux/reducers/whoIsOutReport.reducer";
import mealBreakReport from "../../TimesModule/redux/reducers/mealBreakReport.reducer";
// Users Module
import users from "../../UsersModule/redux/reducers/usersList.reducer";
// Clients Module
import clients from "../../ClientsModule/redux/reducers/clientsList.reducer";
import clientDetails from "../../ClientsModule/redux/reducers/clientDetails.reducer";
import clientBillingInfo from "../../ClientsModule/redux/reducers/clientBillingInfo.reducer";
import clientContacts from "../../ClientsModule/redux/reducers/clientContacts.reducer";
import clientContactProfile from "../../ClientsModule/redux/reducers/clientContactProfile.reducer";
import clientNewContact from "../../ClientsModule/redux/reducers/clientNewContact.reducer";
import clientPriceExceptions from "../../ClientsModule/redux/reducers/clientPriceExceptions.reducer";
import clientInvoices from "../../ClientsModule/redux/reducers/clientInvoices.reducer";
import clientDropdowns from "../../ClientsModule/redux/reducers/clientDropdownsInfo.reducer";
import clientWorkInfo from "../../ClientsModule/redux/reducers/clientWork.reducer";
import clientRelationshipReviewList from "../../ClientsModule/redux/reducers/clientRelationshipReviewsList.reducer";
import clientKeyContacts from "../../ClientsModule/redux/reducers/clientKeyContacts.reducer";

// Avoid persistence when there's a new version.
const APP_VERSION = process.env.REACT_APP_CURRENT_GIT_SHA;
const newVersion = localStorage.APP_VERSION !== APP_VERSION;

if (newVersion) {
  window.location.reload();
}

const persistConfigFilters = {
  key: "filters",
  storage,
};

const persistedFilters = persistReducer(persistConfigFilters, filters);

const persistConfigBillableHours = {
  key: "billableHours",
  storage,
};

const persistedBillableHours = persistReducer(
  persistConfigBillableHours,
  billableHours
);

export default combineReducers({
  //shared
  auth: auth,
  ui: ui,
  home: home,
  uiShared: uiShared,
  //billing
  metaBilling: metaBilling,
  filters: persistedFilters,
  billableHours: persistedBillableHours,
  billableItems: billableItems,
  invoices: invoices,
  //products
  spotlightReportProducts: spotlightReportProducts,
  metaProducts: metaProducts,
  products: products,
  spotlight: spotlight,
  successCriteria: successCriteria,
  // times
  metaTimes: metaTimes,
  times: times,
  timesQuery: timesQuery,
  queryResults: queryResults,
  approvalTime: approvalTime,
  entryHourBox: entryHourBox,
  approvalTimeByUser: approvalTimeByUser,
  timeConfirmation: timeConfirmation,
  timeConfirmationResult: timeConfirmationResult,
  whoIsOutReport: whoIsOutReport,
  mealBreakReport: mealBreakReport,
  // users
  users: users,
  // clients
  clients: clients,
  clientDetails: clientDetails,
  clientBillingInfo: clientBillingInfo,
  clientContacts: clientContacts,
  clientContactProfile: clientContactProfile,
  clientNewContact: clientNewContact,
  clientPriceExceptions: clientPriceExceptions,
  clientInvoices: clientInvoices,
  clientDropdowns: clientDropdowns,
  clientWorkInfo: clientWorkInfo,
  clientRelationshipReviewList: clientRelationshipReviewList,
  clientKeyContacts: clientKeyContacts,
});
